import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/juwie_logo.png'


const _withScopeId = n => (_pushScopeId("data-v-b2d94dac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("h1", null, "Giveaway Central")
], -1))
const _hoisted_3 = { class: "auth" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "px-3" }, "Conectar à Twitch", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_p_button = _resolveComponent("p-button")!
  const _component_p_message = _resolveComponent("p-message")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_p_button, {
        "aria-label": "Conectar à Twitch",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onLoginWithTwitchButtonPressed()))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_font_awesome_icon, { icon: "fa-brands fa-twitch" }),
          _hoisted_4
        ]),
        _: 1
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (msg) => {
        return (_openBlock(), _createBlock(_component_p_message, {
          severity: msg.severity,
          closable: false,
          key: msg.content
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(msg.content), 1)
          ]),
          _: 2
        }, 1032, ["severity"]))
      }), 128))
    ])
  ]))
}